export default __webpack_public_path__ + "static/media/ps-icon.65baf47b.svg";